export default __webpack_public_path__ + "static/quiz-bg-answer-9c2911ac12c3daf18b99cc03d85e8eda.jpg";